import api from '../../utils/api';

const RELEASE_STATUSES = ['released', 'in_review', 'not_shared'];

export const getAssessmentResultRelease = async (assessmentType, sessionId) => {
  if (!sessionId) return false;
  try {
    const response = await api.get(`/assessment-ai/release-status/${assessmentType}/${sessionId}/`);
    return response.data?.results_released === true;
  } catch (error) {
    console.error(`Could not confirm ${assessmentType} result visibility:`, error);
    // Fail closed so an access-setting or provider check failure never exposes scores in chat.
    return false;
  }
};

// Only picks the wording of the support message; whether scores are shown is decided by getAssessmentResultRelease.
export const getAssessmentReleaseStatus = async (assessmentType, sessionId) => {
  if (!sessionId) return 'in_review';
  try {
    const response = await api.get(`/assessment-ai/release-status/${assessmentType}/${sessionId}/`);
    const releaseStatus = response.data?.release_status;
    return RELEASE_STATUSES.includes(releaseStatus) ? releaseStatus : 'in_review';
  } catch (error) {
    console.error(`Could not load ${assessmentType} release status:`, error);
    return 'in_review';
  }
};

export const counselorSupportMessage = (language = 'en', releaseStatus = 'in_review') => {
  if (releaseStatus === 'not_shared') {
    return language === 'fil'
      ? 'Salamat sa pagsagot. Naka-save ang iyong mga sagot. Sa ngayon, hindi ibinabahagi ng iyong paaralan ang mga resultang ito sa mga estudyante. Kung gusto mong makipag-usap, <a href="/appointments">humiling ng pakikipag-usap sa counselor</a>.'
      : 'Thank you for completing the assessment. Your answers are saved. Your school isn’t sharing these results with students right now. If you’d like to talk, <a href="/appointments">request a conversation with a counselor</a>.';
  }
  return language === 'fil'
    ? 'Salamat sa pagsagot. Naka-save ang iyong resulta at susuriin ito ng guidance counselor bago ipakita sa iyo. Kung gusto mong makipag-usap, <a href="/appointments">humiling ng pakikipag-usap sa counselor</a>.'
    : 'Thank you for completing the assessment. Your result is saved and will be reviewed by a school counselor before it is released to you. If you’d like to talk, <a href="/appointments">request a conversation with a counselor</a>.';
};
